unit MedicineItemType;
{

/* Initial. */

}
interface

type
  TMedicineItemType = class
  private
    fMedicineKey: String;
    fName: String;
    fActive: Boolean;
  public
    property MedicineKey: String read fMedicineKey;
    property Name: String read fName;
    property Active: Boolean read fActive;
  end;

implementation

end.
